declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

let isInitialized = false

export function initMetaPixel() {
  if (isInitialized) return
  isInitialized = true

  // Meta Pixel base code
  const f = window
  const b = document
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  b.head.appendChild(t)

  // Initialize with your Pixel ID
  window.fbq('init', '2169607650508214')
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Vientre Plano 50+',
      content_type: 'product',
      value: 19.0,
      currency: 'EUR',
    })
  }
}
